let computed = require('../computed/account');

module.exports = {
    setComputedFields (args, state) {
        computed.subnavigationElements(state);
        computed.contentComponents(state);
    },

    isShowLocalOrder ({ showLocal }, state, output) {
        if (showLocal && showLocal == 'true') {
            output.yes();
            return;
        }
        output.no();
    }
};



// WEBPACK FOOTER //
// ./actions/account/index.js